import { createContext, useContext } from 'react';
import type { GridStrategy } from '../../grid/grid-strategy';

export interface GridSettings {
  enabled: boolean;
  type: 'square' | 'hex';
  size: number;
  offsetX: number;
  offsetY: number;
  opacity: number;
  showLabels: boolean;
  clipToImage: boolean;
  distancePerUnit?: number;
  distanceUnit?: string;
}

export interface GridContextType {
  gridSettings: GridSettings;
  gridOrigin: { x: number; y: number };
  activeMapId: number | null;
  gridStrategy: GridStrategy | null;
  isGridReady: boolean;
}

export const GridContext = createContext<GridContextType | null>(null);

export const useGrid = () => {
  const context = useContext(GridContext);
  if (!context) throw new Error('useGrid must be used within a GridProvider');
  return context;
};